import { Injectable } from '@angular/core';
import { String } from "typescript-string-operations";
import { AuthKey } from "../model/auth.key";
import { Store } from "@ngrx/store";
import { firstValueFrom } from "rxjs";
import { RestService } from '../../../services/rest.service';
import { AuthSelectors } from '../../authentication';

@Injectable({
  providedIn: 'root'
})
export class AuthKeyService {

  public static readonly NodeIntergration = 'auth-key/';
  public static readonly NodeOrg = AuthKeyService.NodeIntergration + 'search/?orgId={0}';
  public static readonly NodeKey = AuthKeyService.NodeIntergration + '?keyId={0}';

  constructor(
    private restService: RestService,
    private store: Store
  ) {
  }

  async readAll(orgId: string) {
    const url = String.format(
      AuthKeyService.NodeOrg,
      orgId
    );
    return (
      await this.restService.send<AuthKey[]>({
        url: url,
        method: 'GET',
      })
    ).data;
  }

  async createKey(name: string, expiry: Date) {

    const activeOrg = await firstValueFrom(this.store.select(AuthSelectors.selectActiveAccount))

    return (await this.restService.send<AuthKey>({
      url: AuthKeyService.NodeIntergration,
      method: 'POST',
      body: {
        org: activeOrg._id,
        featuresAllowed: ['jello'],
        expiry: expiry,
        name: name,
      }
    })).data;
  }


  async deleteKey(key: string) {
    const url = String.format(
      AuthKeyService.NodeKey,
      key
    );
    return (await this.restService.send<AuthKey>({
      url: url,
      method: 'DELETE',
    })).data;
  }

}
